(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name user.directive:adduser
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
   <example module="user">
   <file name="index.html">
   <adduser></adduser>
   </file>
   </example>
   *
   */
  angular
    .module('user')
    .directive('adduser', adduser);

  function adduser() {
    return {
      restrict: 'EA',
      scope: {},
      templateUrl: 'user/adduser-directive.tpl.html',
      replace: false,
      controllerAs: 'uCtrl',
      bindToController: true,
      controller: 'UserCtrl',
      link: function (scope, element, attrs) {
        /* jshint unused:false */
        /* eslint "no-unused-vars": [2, {"args": "none"}] */
      }
    };
  }
}());
